<template>
    <div class="page-content">
        <div v-if="licensesNotPaid > 0" class="mb-4 red-gradient-warn">
            <p>Ai achiziționat <strong>{{ licensesNotPaid }}</strong> <span v-if="licensesNotPaid === 1">licență</span><span v-else>licențe</span> pentru care plata este în curs de confirmare. Poți încărca OP-ul de plată <router-link to="/aplicatii/m3-sketch/licente/contracte-facturi">aici</router-link> sau ne poți contacta pentru detalii suplimentare la office@smis.ro</p>
        </div>
        <b-overlay v-if="!loading" :show="licenseLoading" :opacity="opacity" :blur="blur" :variant="licenseVariant">
            <template #overlay>
                <div class="loading-overlay">
                    <b-spinner></b-spinner>
                    <p style="text-align: center; margin-bottom: 5px; font-size: 15px;" :style="licenseWhite ? 'color: #ffffff !important' : ''">{{ loadingText }}</p>
                </div>
            </template>
            <div class="white-box">
                <div class="table-header flex space-between align-center">
                    <div class="item-table-header">
                        <p>Licențe achiziționate: <span :class="licenseData.licensesUsed + licenseData.licensesAvailable < 1 ? 'red-danger' : 'green-bold'">{{ licenseData.licensesUsed + licenseData.licensesAvailable }}</span></p>
                        <p v-if="licensesNotPaid > 0" class="red-info-text">Licențe neachitate: <strong>{{ licensesNotPaid }}</strong></p>
                    </div>
                    <div class="item-table-header">
                        <p>Licențe disponibile: <span :class="licenseData.licensesAvailable < 1 ? 'red-danger' : 'green-bold'">{{ licenseData.licensesAvailable }}</span></p>
                    </div>
                    <div class="item-table-header">
                        <p>Licențe utilizate: <span class="red-danger">{{ licenseData.licensesUsed }}</span></p>
                    </div>
                </div>
                <b-table v-if="firme && firme.length > 0" id="TabelLicente" sticky-header striped hover :items="firme" :fields="fields" head-variant="light">
                    <template v-slot:cell(company)="data">
                        <span>{{ data.value }}</span>
                    </template>
                    <template v-slot:cell(paid)="data">
                        <b-icon-check-circle-fill v-if="data.value" font-scale="1" class="success-icon"></b-icon-check-circle-fill>
                        <b-icon-x-circle-fill v-else font-scale="1" class="danger-icon"></b-icon-x-circle-fill>
                    </template>
                    <template v-slot:cell(license)="data">
                        <b-button v-if="data.value" class="n-active-license" >Licență activă</b-button>
                        <router-link v-else-if="!data.value && licenseData.licensesAvailable === 0" to="/aplicatii/m3-sketch/licente/comanda-licenta" class="active-license">Cumpără licență</router-link>
                        <b-button v-else class="active-license" @click="activateLicense(data.item.id, data.item.company)">Activează licența</b-button>

                    </template>
                </b-table>
                <p v-else class="notice-text">Momentan nu există companii adăugate pe acest cont.</p>
            </div>
        </b-overlay>
        <LoadingSpinner v-else style="min-height: 400px;"></LoadingSpinner>
    </div>
</template>

<script>
    import LoadingSpinner from '@/common/components/LoadingSpinner'
    import {BFormCheckbox, BTable, BIconX, BIconCheckCircleFill, BIconXCircleFill, BButton, BOverlay, BSpinner} from 'bootstrap-vue'
    import axios from '@/helpers/axios';
    import api from '@/helpers/api';
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb';
    /*import _ from "lodash";*/
    export default {
        name: 'LicenteleMele',
        components: {
            SketchBreadcrumb,
            BFormCheckbox,
            BTable,
            BIconX,
            BIconCheckCircleFill,
            BIconXCircleFill,
            BButton,
            LoadingSpinner,
            BOverlay,
            BSpinner
        },
        props: {
            licenseData: null,
            licensesNotPaid: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                /* LOADING */
                licenseLoading: false,
                opacity: 0.95,
                blur: '20px',
                licenseVariant: 'light',
                licenseWhite: false,
                loadingText: 'Licența este în curs de atribuire',

                loading: true,
                companies: [],
                fields: [
                    {
                        key: 'company',
                        label: 'Companie',
                        class: 'company-name-l',
                    },
                    {
                        key: 'paid',
                        label: 'Licență',
                        class: 'license-status-l',
                    },
                    {
                        key: 'license',
                        label: 'Activare',
                        class: 'activare-btn-l',
                    },
                ],
                firme: [],
            }
        },
        watch: {},
        mounted() {
            this.getCompanies()
        },
        methods: {
            getCompanies() {
                axios.get(api.API_ENDPOINTS.m3company)
                    .then(response => {
                        response.data.forEach(companie => {
                            this.firme.push({
                                id: companie.id,
                                company: companie.name,
                                paid: companie.paid,
                                license: companie.paid
                            })
                        })
                    }).finally(() => {this.loading = false})
            },
            activateLicense(id, name) {
                if(this.licenseData.licensesAvailable < 1) {
                    this.$toast.error('Nu există licențe disponibile.')
                } else {
                    this.$swal({
                        heightAuto: false,
                        title: `Licența va fi activată pe compania <br><span style="font-weight: 700;">` + name + `</span><br><br>Licența nu se poate dezactiva după activare.<br>Ești sigur că vrei să continui?`,
                        body: `test`,
                        icon: 'warning',
                        confirmButtonText: 'Continuă',
                        showDenyButton: true,
                        denyButtonText: 'Anulează'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.licenseLoading = true
                            axios.post(api.API_ENDPOINTS.m3company + id + '/activate')
                                .then(response => {
                                    this.licenseVariant = 'success'
                                    this.loadingText = 'Licența a fost atribuită cu succes!'
                                    this.licenseWhite = true
                                    this.$toast.success(response.data.message)
                                    let company = JSON.parse(localStorage.getItem('currentM3Company'))
                                    company.paid = true;
                                    localStorage.removeItem('currentM3Company');
                                    localStorage.setItem('currentM3Company', JSON.stringify(company));
                                    setTimeout(() => {
                                        location.reload();
                                        this.licenseVariant = 'light'
                                        this.licenseLoading = false
                                        this.licenseWhite = false
                                        this.loadingText = 'Licența este în curs de atribuire'
                                    }, 400)
                                }).catch((xhr) => {
                                    this.licenseVariant = 'danger'
                                    this.licenseWhite = true
                                    this.loadingText = 'A apărut o eroare la atribuirea licenței!'
                                    setTimeout(() => {
                                        this.licenseVariant = 'light'
                                        this.licenseLoading = false
                                        this.licenseWhite = false
                                        this.loadingText = 'Licența este în curs de atribuire'
                                    }, 1000)
                                    if (xhr && xhr.response && xhr.response.status === 403) {
                                        this.$toast.error(xhr.response.data.message)
                                    }
                                })
                        }
                    })
                }
            }
        }
    }
</script>

<style>
#TabelLicente tr{
    background: rgba(0, 0, 0, 0.05) !important;
}
</style>
<style scoped>
/* LOADING */
.loading-overlay{
    width: 100%;
    text-align: center;
}
.loading-overlay p{
    margin-top: 15px;
}
.loading-overlay >>> .progress{
    min-width: 350px;
}
.loading-overlay >>> .progress-bar{
    background-color: inherit;
    background: linear-gradient(to right,#69586e, #22686c);
}
.error-progress >>> .progress-bar{
    background: #ff7070 !important;
}
.error-progress >>> p{
    color: #fff !important;
}

.notice-text{
    text-align: center;
    margin: 60px 0 20px 0;
    font-size: 14px;
}
.red-info-text{
    font-size: 14px !important;
    color: #f88f94 !important;
    font-weight: 400 !important;
    margin-top: -5px;
}
.red-gradient-warn{
    background: linear-gradient(to bottom, #fd968d, #f78d96);
    padding: 10px 45px;
}
.red-gradient-warn p{
    color: #fff;
    font-size: 13px;
}
.red-gradient-warn a{
    color: #fff;
    font-weight: 600;
    text-decoration: none;
}
.swal2-popup >>> .swal2-title{
    font-size: 14px;
}
.white-box{
    background: #fff;
    padding: 20px;
    height: 100%;
}
.active-license,
.n-active-license {
    background: linear-gradient(to bottom, #8c6984, #816e8b);
    color: #fff;
    border-radius: 2px;
    padding: 3px 15px;
    font-size: 13px;
    border:none;
    min-width: 140px;
    text-decoration: none;
}
.n-active-license {
    background: #49cda8;
}
.n-active-license:hover {
    background: #36987d;
    transition: all 0.3s;
}

.has-icon{
    position: relative;
}
.has-icon img{
    position: absolute;
    top: 0;
    right: 10px;
    opacity: 0.3;
    bottom: 0;
    margin: auto 0;
}
#TabelLicente .red-bold{
    color: #ea8196 !important;
    font-weight: 700;
}
#TabelLicente .green-bold{
    color: #49cda8 !important;
    font-weight: 700;
}
.padding-box {
    padding: 20px 20px 0 20px;
}


.flex {
    display: flex;
}
.warn-icon{
    color: #ffc43f;
}
.danger-icon{
    color: #ea8196 !important
}
.success-icon{
    color: #49cda8 !important
}
.space-between {
    justify-content: space-between;
}

.justify-content-center {
    justify-content: center;
}

.table-header {
    font-size: 14px;
    color: #5b6276;
    font-weight: 500;
    min-height: 115px;
    padding: 0 20px;
}

tbody span {
    color: #777e90;
    font-size: 12px;
    font-weight: 500;
}
.form-group{
    margin: 0;
}
input{
    border-radius: 0;
    font-size: 13px;
    margin: 5px 0;
    color: #53596e;
    text-align: left;
    background: #e9ecef;
}
input:focus{
    color: #53596e;
    background: #e9ecef;
}
tr {
    text-align: center !important;
}

.absolute-left {
    position: absolute;
    left: 10%;
    bottom: 40%;
    z-index: 0;
}

.icons svg:not(:last-child) {
    margin-right: 10px;
}

.icons svg {
    font-size: 17px;
}

.padding-box .table-responsive {
    overflow-y: auto;
    max-height: calc(100% - 122px);
}
.b-table-sticky-header{
    max-height: calc(100% - 122px);
}
.b-table-sticky-header, .table-responsive {
    margin-bottom: 0;
}

.ml-1 {
    margin-right: 10px;
}

.item-table-header {
    width: 100%;
    height: 100%;
    min-height: 45px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    border-right: 3px dotted #caccd2;
}

.item-table-header:last-child {
    border-right: 0;
}

.item-table-header p {
    font-size: 19px;
    color: #545a6f;
    letter-spacing: -0.3px;
    font-weight: 400;
}

.red-text {
    color: #836e8b !important;
}

.green-bold {
    color: #49cda8 !important;
    font-weight: 700;
}

.red-danger {
    color: #ea8196 !important;
    font-weight: 700;
}
.table-header {
    font-size: 14px;
    color: #5b6276;
    font-weight: 500;
    min-height: 75px;
    padding: 0 20px;
}
@media (max-width: 1500px) {
    .item-table-header p{
        text-align: center;
    }
    .item-table-header img{
        max-height: 30px;
        object-fit: contain;
        padding: 0 10px;
    }
    .white-box {
        padding-right: 0;
    }
}

</style>
<style>
#TabelLicente .company-name-l{
    width: 65%;
}
#TabelLicente .license-status-l {
    width: 15%;
    max-width: 230px;
}

#TabelLicente .activare-btn-l{
    width: 25%;
}
#TabelLicente th{
    font-size: 13px;
    font-weight: inherit;
}
#TabelLicente{
    text-align: center;
}
#TabelLicente td{
    padding: 0.45rem;
    vertical-align: middle;
}
#TabelLicente thead .company-name-l{
    font-weight: bold;
}
@media screen and (max-width:1240px){
    #TabelLicente .company-name-l {
        width: 50%;
    }
    #TabelLicente .activare-btn-l {
        width: 40%;
    }

}
</style>
